/**
 * System-wide UI related events.
 */
export const REPORT_ERROR = 'REPORT_ERROR';
